export const TUDO_AZUL_TRAVEL = {
  Header: 'T&C - TRAVEL E TUDO AZUL',
  Body: [
    {
      Title: 'Regras Gerais – Acúmulo:',
      Paragraphs: [
        `1. Clientes cadastrados no programa Tudo Azul ganharão 4 (quatro) pontos por
        real gasto na Loja Tudo Azul dentro de Rappi Travel, no Aplicativo Rappi.`,
        `2. A pontuação será creditada em até 15 dias úteis após a confirmação da
        compra contados da utilização do produto pelo cliente (checkout em hotel, passagens já utilizadas, passeios
        utilizados, entre outros), pelo cliente, do produto adquirido no Rappi, desde que o número do CPF informado
        seja válido. O  Rappi e a Tudo Azul não se responsabilizam pela informação incorreta, pelo consumidor, do
        número de CPF. `,
        '3. A pontuação creditada no TudoAzul terá um prazo de validade de 24 meses. ',
        `4. A quantidade de Pontos Tudo Azul será calculada sobre o montante do valor dos produtos adquiridos no aplicativo
        Rappi, na loja Tudo Azul em Rappi Travel.  `,
        `5. O crédito de Pontos Tudo Azul será realizado no mesmo número CPF daquele realizador da compra (informado no
          cadastro do parceiro e/ou fluxo de compra), não sendo permitida a doação dos Pontos a terceiros.  `,
        '6. Promoção válida das <strong>0h01 do dia 12/11/20 até 23:59 do dia 28/02/2021</strong>',
        `7. Regras gerais continuam inalteradas, consulte no site: <a
        href="https://tudoazul.voeazul.com.br/web/azul/terms-and-conditions">
        https://tudoazul.voeazul.com.br/web/azul/terms-and-conditions</a>`,
      ]
    }
  ]
};
